<template>
  <div :class="['op--modal-container', {hide: !show}]" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="datetimepicker" @click.stop>
          <div class="datetimepicker-box">
            <div class="row">
              <div class="column small-12">
                <!-- <div class="title">
                  <span>{{ $t('searchForm.selectDeparture') }}</span>
                </div> -->
                <div class="trip-type d-flex">
                  <label @click="tripType = 'single'">
                    <input type="radio" name="tripType" value="single" v-model="tripType" />
                    One Way
                  </label>
                  <label @click="tripType = 'roundtrip'">
                    <input type="radio" name="tripType" value="roundtrip" v-model="tripType" />
                    Round Trip
                  </label>
                </div>
                <div class="d-flex book-calendar" v-if="render">
                  <div>
                    <!-- <span v-if="isMobile">Departure: {{printDate(selectedDate)}}</span> -->
                    <span>Select Departure Date</span>
                    <datepicker :inline="true" v-on:input="changeDate($event, 'single')" @selected="fixReturnCalendar"
                    v-model="selectedDate" :disabled="disabledDate">
                    </datepicker>
                  </div>
                  <div>
                    <!-- <span v-if="tripType == 'roundtrip' && isMobile">Return: {{printDate(returnDate)}}</span> -->
                    <span v-if="tripType == 'roundtrip'">Select Return Date</span>
                    <div id="rtDatepicker">
                      <datepicker :inline="true" :minimumView="'month'" v-on:input="changeDate($event, 'roundtrip')"
                      v-model="returnDate" :disabled="disabledDateReturn" v-show="tripType == 'roundtrip'">
                    </datepicker>
                    </div>
                  </div>
                </div>
                <div class="date-error-msg" v-if="!!errorMsg">{{errorMsg}}</div>
                <div class="buttons">
                  <span class="op-btn btn-lg btn-success btn-block margin-t-s" @click="setDate">{{ $t('serviceSelect.apply') }}</span>
                  <div class="cancel-pickup margin-t-s">
                    <span @click="close">{{ $t('common.cancel') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'departure-modal',
  components: { Datepicker },
  props: ['noCommit'],
  data () {
    return {
      tripType: 'roundtrip',
      selectedDate: moment.tz(this.$store.state.reservation.leg1.timezone).format('MM/DD/YYYY'),
      returnDate: moment.tz(this.$store.state.reservation.leg1.timezone).add(9, 'days').format('MM/DD/YYYY'),
      today: moment.tz(this.$store.state.reservation.leg1.timezone),
      errorMsg: '',
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
      render: true
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    d2dTimeBuffer () { return this.booking.settings.timeBuffer },
    show () { return this.booking.filters.departure.show },
    webTimeBuffer () { return this.$store.state.reservation.webTimeBuffer },
    dateTimePickerData () { return this.$store.state.serviceSelection.dateTimePicker },
    disabledDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
    disabledDateReturn () {
      if (!this.selectedDate) return this.disabledDate
      let date = moment(this.selectedDate, 'MM/DD/YYYY')
      if (date.format('MM') === '01') {
        return {
          to: new Date(
            date.subtract(1, 'months').format('YYYY'),
            date.format('MM'),
            date.format('DD')
          )
        }
      }

      return {
        to: new Date(
          date.format('YYYY'),
          date.subtract(1, 'months').format('MM'),
          date.format('DD')
        )
      }
    },
    isMilitaryTime () {
      if (this.$store.state.reservation.charter.MilitaryTimeWidget) {
        this.hourFormat = 'HH'
        this.maxHour = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      }
      return this.$store.state.reservation.charter.MilitaryTimeWidget
    }
  },
  methods: {
    close () {
      this.$store.commit('booking/setDepartureData', {show: false})
    },
    changeDate (val, type) {
      let date = moment(val)
      let format = 'MM/DD/YYYY'
      if (type === 'single') {
        this.selectedDate = date.format(format)
        let returnDate = moment(this.returnDate, format)
        if (!date.isBefore(returnDate)) this.returnDate = date.format(format)
      } else {
        this.returnDate = date.format(format)
        let startDate = moment(this.selectedDate, format)
        if (date.isBefore(startDate)) this.selectedDate = date.format(format)
      }
    },
    setDate () {
      this.errorMsg = ''
      if (this.tripType === 'roundtrip') {
        let startDate = moment(this.selectedDate, 'MM/DD/YYYY')
        let endDate = moment(this.returnDate, 'MM/DD/YYYY')
        if (!startDate.isBefore(endDate) && this.selectedDate !== this.returnDate) {
          this.errorMsg = 'Return Trip must be in the future.'
          return
        }
      }
      if (this.noCommit) {
        this.$emit('dateVal', {
          date: this.selectedDate,
          return: this.returnDate,
          isReturning: this.tripType === 'roundtrip'
        })
      } else {
        this.$store.commit('booking/setDepartureData', {
          date: this.selectedDate,
          return: this.returnDate,
          isReturning: this.tripType === 'roundtrip'
        })
      }
      this.$emit('newDate')
      this.close()
    },
    printDate (date) {
      return moment(date).format('MMM DD, YYYY')
    },
    fixReturnCalendar () {
      let self = this
      self.$nextTick(() => {
        let tmp2 = JSON.parse(JSON.stringify(self.returnDate))
        self.returnDate = this.selectedDate
        setTimeout(() => {
          self.returnDate = tmp2
        }, 50)
      })
    }
  },
  watch: {
    tripType (val) {
      this.errorMsg = ''
    },
    d2dTimeBuffer (val) {
      // this.today = moment().add(val, 'minutes')
      this.selectedDate = moment().add(val, 'minutes').add(2, 'days').format('MM/DD/YYYY')
      this.returnDate = moment().add(val, 'minutes').add(9, 'days').format('MM/DD/YYYY')

      let self = this
      self.$nextTick(() => {
        if (self.selectedDate.substring(0, 2) !== self.returnDate.substring(0, 2)) {
          let el = document.querySelector('#rtDatepicker .vdp-datepicker__calendar header .prev')
          el.click()
        }
      })
    },
    show (val) {
      if (val) {
        this.tripType = this.booking.filters.departure.isReturning ? 'roundtrip' : 'single'
      }
    }
  },
  mounted () {
    this.tripType = this.booking.filters.departure.isReturning ? 'roundtrip' : 'single'
    this.selectedDate = moment().add(this.d2dTimeBuffer, 'minutes').add(2, 'days').format('MM/DD/YYYY')
    this.returnDate = moment().add(this.d2dTimeBuffer, 'minutes').add(9, 'days').format('MM/DD/YYYY')

    let self = this
    self.$nextTick(() => {
      if (self.selectedDate.substring(0, 2) !== self.returnDate.substring(0, 2)) {
        let el = document.querySelector('#rtDatepicker .vdp-datepicker__calendar header .prev')
        el.click()
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}
.datetimepicker{
  background-color: #fff;
  max-width: 520px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
}

.datetimepicker-tab{
  margin-bottom: 10px;
  display: flex;

  span{
    background: #f6f6f6;
    border-bottom: 1px solid #ddd;
    padding: 10px;
    text-align: center;
    width: 50%;
    display: inline-block;
    cursor: pointer;
    color: #555;

    i{ margin-right: 5px; }
    &.active{
      background: #fff;
      border: none;
    }
    &:not(.active){
      box-shadow: 0 -1px 1px rgba(0,0,0, .05) inset;
      color: #aaa;
    }
    &:first-child:not(.active){ border-right: 1px solid #ddd }
    &:last-child:not(.active){ border-left: 1px solid #ddd }
  }
}
.datetimepicker-box {
  padding: 20px;

  .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 5px;
    font-size: 18px;
  }

  .separator {
    &::after {
      content: "or";
    }
  }
  .book-calendar{
    span{
      text-align: center;
      display: block;
    }
  }
}
.trip-type{
  justify-content: space-around;
  margin: 10px 0;
  font-weight: 600;

  input{
    vertical-align: -2px;
    margin-right: 4px;
    font-weight: 600;
  }
}
.estimated-dropoff{
  color: #777;
  font-size: 14px;
  font-style: italic;
}

.pickuptime{
  text-align: center;
  display: block;
  padding-left: 10px;

  .title { margin-bottom: 0; }
  .select{
    position: relative;
    display: inline-block;
    width: 50px;
    text-align: center;
    margin: 25px 10px 0;

    .label{
      padding: 10px 10px 5px;
      font-size: 22px;
      line-height: 22px;

      .icon{ float: right; }
    }
    .fas{
      left: 50%;
      padding: 0 5px;
      color: #495057;
      cursor: pointer;
      position: absolute;
      transform: translateX(-50%);
      transition: all .2s ease-out;

      &.increase{ top: -30px; }
      &.decrease{ top: calc(100% + 3px); }
      &.highlight{ background: #d2f0ff; }
    }

    select{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
    &.border{
      border-left: 0;
    }
  }

  .pickuptime-rule{
    font-size: 13px;
    display: block;
    color: #aaa;
  }

  .pickuptime-rule{
    font-size: 13px;
    display: block;
    color: #aaa;
  }
  .pickuptime-ui{ margin-top: 10px; }

  .buttons{
    margin-top: 50px;
    padding-left: 7px;
  }
}

.date-error-msg{
  font-size: 14px;
  padding: 5px;
  display: block;
  color: #ef4b4b;
  background: #fde5e5;
  border-radius: 4px;
  border: 1px solid #ef4b4b;
  line-height: 1.4;
  margin-top: 10px;
}

.cancel-pickup{
  text-align: center;
  span{
    padding: 2px 5px;
    cursor: pointer;
    color:#aaa;

    &:hover{
      text-decoration:underline;
      color:#777;
    }
  }
}

@media only screen and (max-width: 639px) {
  .datetimepicker-box .pickuptime{
    margin-top: 20px;
    padding-left: 0;

    .buttons{ padding-left: 0; }
  }

  .book-calendar {
    flex-direction: column;
    gap: 15px;
    text-align: left;

    span {
      font-size: 12px;
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// DateTimePicker.vue?4150e8c7